"use client"

import { deleteLineItem } from "@/lib/data/cart"
import { useRef, useState } from "react"

export const DeleteCartItemButton = ({
  id,
  onSuccess,
  onDeleting,
  onDeleteFailed,
}: {
  id: string
  onSuccess: () => void
  /** Fires immediately so the parent can play a leave animation. */
  onDeleting?: () => void
  onDeleteFailed?: () => void
}) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const [isHot, setIsHot] = useState(false)
  const hotTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const handleDelete = async () => {
    if (isDeleting) return

    setIsDeleting(true)
    setIsHot(true)
    onDeleting?.()

    try {
      await deleteLineItem(id)
      onSuccess()
    } catch {
      setIsDeleting(false)
      setIsHot(false)
      onDeleteFailed?.()
    }
  }

  return (
    <button
      type="button"
      className={`bb-trash ${isDeleting ? "bb-trash--deleting" : ""} ${
        isHot ? "bb-trash--hot" : ""
      }`}
      aria-label="Remove item"
      disabled={isDeleting}
      onMouseEnter={() => {
        setIsHot(true)
        if (hotTimerRef.current) clearTimeout(hotTimerRef.current)
      }}
      onMouseLeave={() => {
        if (isDeleting) return
        hotTimerRef.current = setTimeout(() => setIsHot(false), 120)
      }}
      onClick={handleDelete}
    >
      <svg
        className="bb-trash-icon"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
      >
        {/* lid */}
        <path
          className="bb-trash-lid"
          d="M9 4.5h6M8 7h8"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          className="bb-trash-lid-cap"
          d="M10 4.5h4"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        {/* can */}
        <path
          className="bb-trash-can"
          d="M7.5 7.5h9l-.7 11.2a1.5 1.5 0 0 1-1.5 1.4H9.7a1.5 1.5 0 0 1-1.5-1.4L7.5 7.5Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <path
          className="bb-trash-lines"
          d="M10.5 10.5v6M13.5 10.5v6"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
      <span className="bb-trash-ripple" aria-hidden />
    </button>
  )
}
